module.exports = __webpack_public_path__ + "icons/original/large/large-a2.b09094efecdd9eb43f5c9d816a1fe4e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-a2.png
// module id = NhLW
// module chunks = app